export const arr_ensure = ( data ) => (Array.isArray(data) ?
	data
	: (data ? [ data ] : [])
);
